<template>
  <v-container>
  <div>
    <div class="btn-grid mt-5">
      <!-- <v-layout mx-auto justify-center> -->
        <div class="btn_container">
          <div @click="showMenu(0)">
            <button class="main_btn">
              <img :src="base" class="icon_size"/>
              <div>BASE</div>
            </button>
          </div>
          <transition name="fade">
            <div class="sub_container" v-if="ShowMenu[0]">
              <v-btn class="menu_btn" href="/base/weather">기상<br/> 모니터링</v-btn>
              <v-btn class="menu_btn" href="/base/summary" >환경 센서<br/> 모니터링</v-btn>
              <v-btn class="menu_btn" href="/base/wattagedetail">에너지 사용량<br/> 모니터링</v-btn>
            </div>
          </transition>
        </div>
        
        <div class="btn_container">
          <div @click="showMenu(1)">
            <button class="main_btn"  v-if="service.dailyrecord">
              <img :src="dailyrecord" class="icon_size"/>
              <div>관리일지</div>
            </button>
          </div>

          <transition name="fade">
            <div class="sub_container" v-if="ShowMenu[1]">
              <v-btn class="menu_btn" href="/record/growdata">사육 데이터</v-btn>
              <v-btn class="menu_btn" href="/record/shipdata">출하 데이터</v-btn>
              <v-btn class="menu_btn" href="/record/marketinfo">시장 정보</v-btn>
            </div>
          </transition>
        </div>
      </div>
      <!-- </v-layout> -->
      
      <div class="btn-grid second">
      <!-- <v-layout mx-auto justify-center class="mt-15"> -->
        <div class="btn_container">
          <div @click="showMenu(2)">
            <button class="main_btn" v-if="service.fancontrol">
              <img :src="fancontrol" class="icon_size"/>
              <div>환기</div>
            </button>
          </div>

          <transition name="fade">
            <div class="sub_container" v-if="ShowMenu[2]">
              <v-btn class="menu_btn" href="/control/controlSensorsummary">환기 센서<br/> 모니터링</v-btn>
              <v-btn class="menu_btn" href="/control/controlset" v-show="$getters.userInfo.grade < 'UT06' ">환기 제어<br/> 설정</v-btn>
              <v-btn class="menu_btn" href="/control/controlsummary">환기 제어<br/> 모니터링</v-btn>
              <v-btn class="menu_btn" href="/control/controltable" v-show="$getters.userInfo.grade < 'UT06' ">계절별 <br/> 환기 설정</v-btn>
            </div>
          </transition>
        </div>

        <div class="btn_container">
          <div @click="showMenu(3)">
            <button class="main_btn" v-if="service.deodorizer">
              <img :src="deodorizer" class="icon_size"/>
              <div>악취</div>
            </button>
          </div>

        <transition name="fade">
          <div class="sub_container" v-if="ShowMenu[3]">
            <v-btn class="menu_btn" href="/deodorizer/deodorizerSensorsummary">악취 센서<br/> 모니터링</v-btn>
            <v-btn class="menu_btn" href="/deodorizer/DeodorizerDviceMonitoring">기계실<br/> 모니터링</v-btn>
            <v-btn class="menu_btn" v-show="$getters.userInfo.grade < 'UT06' " href="/deodorizer/deodorizerset">악취 제어 설정</v-btn>
            <v-btn class="menu_btn" href="/deodorizer/deodorizermonitoring">악취 제어<br/> 모니터링</v-btn>
          </div>
        </transition>
      </div>

      <div class="btn_container">
        <div @click="showMenu(4)">
          <button class="main_btn" v-if="service.esg">
            <img :src="esg" class="icon_size"/>
            <div>ESG</div>
          </button>
        </div>

        <transition name="fade">
          <div class="sub_container" v-if="ShowMenu[4]">
            <v-btn class="menu_btn" href="/esg/energycost">에너지 요금 <br/> 모니터링</v-btn>
            <v-btn class="menu_btn" href="/esg/monitorEsg">배출량<br/> 모니터링</v-btn>
            <!-- <v-btn class="menu_btn">배출량<br/> 시뮬레이션</v-btn> -->
          </div>
        </transition>
      </div>
    </div>
    </div>
  </v-container>
</template>

<script>
  import Apis from '@/api/apis'
  export default {
    name: 'HomeCard',
    created() {
      this.listAccesableServices();
      Apis.getIpClient((res) => {
        // console.log(res);  
        let client = res
        Apis.pageCount({ //페이지뷰 카운터
          page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
          url: this.$route.path,
          ip: client.ip,
          division: "cloud",
        },() => {  // 정상처리
          // console.log("pageCount 호출",res);
        }).catch( (err) => {  // 개별 API 오류 처리 예제
          console.log("pageCount 호출 오류",err);
        });
      }).catch( (err) => {  // API 오류 처리
          console.log("getIpClient 호출 오류",err)
      }) 
    },
    data: () => ({
      base: require("@/assets/home/barn.svg"),
      dailyrecord: require("@/assets/home/pig-variant-outline.svg"),
      fancontrol: require("@/assets/home/fan.svg"),
      deodorizer: require("@/assets/home/scent.svg"),
      esg: require("@/assets/home/sprout.svg"),

      

      service:{},
      ShowMenu:[false,false,false,false,false],

    }),

    methods: {
      listAccesableServices(){
        this.$store.commit("resMessage","");

        Apis.listAccesableServices({
        },(res) => {  
          // console.log(res.data);
          this.service = res.data;
        }).catch( (err) => {  // API 오류 처리
            console.log("listAccesableServices API 호출 오류",err)
            alert(err);
        }) 
      },
      showMenu(index){
        this.ShowMenu = this.ShowMenu.map((visible, i) => i === index ? !visible : false);
      },
      summary() {
        this.$router.push("/summary")
      },
      barometer() {
        this.$router.push("/barometer")        
      },
      asset() {
        this.$router.push("/asset")                
      },
      control() {                       
        this.$router.push("/control/controlsummary")                               
      },

    },
  }
</script>
<style lang="scss" scoped>
.btn-grid{
  display: flex;
  justify-content: center; /* 수평 중앙 정렬 */
  align-items: center;    /* 수직 중앙 정렬 */
}
.sub_container{
  position: absolute;
  margin-top:20px;
  transform: translate(-20%, -50%);
}
.menu_btn{
  margin-right:10px;
  width:120px !important;
  height:60px !important;
  font-size:16px;
  letter-spacing: -1px;
  font-weight:600;
  text-align: center;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s ease, max-height 0.5s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}

.icon_size{
  width:80px;
  transition: all 0.5s;
}
.main_btn{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border: 2px solid black;
  border-radius: 10px;
  cursor: pointer;
  width:175px;
  height:175px;
  margin:20px;
  transition: all 1s;
}
.main_btn:hover{
  background-color:#191a88;
  color:white;
}
.main_btn:hover .icon_size{
  filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(52deg) brightness(103%) contrast(104%);
}
.main_btn div{
  font-size:22px;
  font-weight:600;
  letter-spacing: -1px;
}
.second{
  margin-top:50px;
}
@media (max-width: 680px) {
  .btn-grid {
    flex-direction: column;
    height:100%;
    margin-top:20px;
  }
  .btn_container {
    display: flex;
    flex-direction: column;
    justify-content: center !important;
    align-items: center !important;
  }
  .second{
  margin-top:0px;
  }
  .main_btn {
    width: 150px;
    height: 150px;
  }
  .icon_size {
    width: 70px;
  }
  .main_btn div {
    font-size: 18px;
  }
  .sub_container {
    position: static;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center; /* Center align the submenu */
    flex-wrap: wrap; /* Allow buttons to wrap if needed */
    transform: translate(0%, 0%);
    margin-top:0px;
    // max-width:20px;
  }
  .menu_btn {
    max-width: 70px !important;
    font-size: 14px;
    margin-bottom: 10px; /* Add margin to separate buttons */
  }
}
</style>
